import { DefaultValueProvider } from './default-value-provider';
import { ModelBase } from './model-base';
import { ModelMetadataContainer } from './model-metadata-container';

export class ModelBuilder {
    public static build(target: ModelBase): void {
        const modelMetadata = <ModelMetadataContainer> Reflect.getMetadata('skl:model', target.constructor);

        modelMetadata.properties
            .map(metadata => metadata.propertyName)
            .forEach(name => Object.defineProperty(target, name, {
                configurable: false,
                set: target.set.bind(target, name),
                get: target.get.bind(target, name)
            }));
    }

    public static populateWithDefaultData(target: ModelBase): void {
        const modelMetadata = <ModelMetadataContainer> Reflect.getMetadata('skl:model', target.constructor);

        modelMetadata.properties
            .forEach(metadata => target.set(metadata.propertyName, metadata.config.nullable ? null : DefaultValueProvider.getDefaultValueOf(metadata.type)));
    }
}
